import { useStaticQuery, graphql } from 'gatsby'

export const useMenuQuery = () => {
const { allWpMenuItem } = useStaticQuery(
    graphql`
    query MenuQuery {
      allWpMenuItem(
        filter: {parentDatabaseId: {eq: 0}, locations: {eq: GATSBY_HEADER_MENU}}
      ) {
        nodes {
          id
          label
          path
           cssClasses
          childItems {
            nodes {
              id
              label
              path
              cssClasses
              childItems {
                nodes {
                  id
                  label
                  path
                  cssClasses
                  childItems{
                      nodes{
                          id
                          label
                          path
                      }
                  }
                }
              }
              
            }
          }
          menu {
            node {
              dropdownpics {
                dropdownPics {
                  dropdownAltText
                  dropdownPic {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          formats: [AUTO, WEBP, AVIF]
                          placeholder: NONE
                        )
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `
);
return allWpMenuItem;
}